import styled from '@emotion/styled';

export const FiltersContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;
`;

export const FilterSelect = styled.select`
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: 4px;
    font-size: 14px;
    color: ${({ theme }) => theme.color.black200};
    background-color: ${({ theme }) => theme.color.white100};
    min-width: 180px;
    cursor: pointer;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.color.emerald};
    }
`;

export const ExportButton = styled.button`
    padding: 8px 16px;
    border: 1px solid ${({ theme }) => theme.color.emerald};
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.white100};
    background-color: ${({ theme }) => theme.color.emerald};
    cursor: pointer;
    margin-left: auto;

    &:hover {
        opacity: 0.9;
    }
`;
